import { render } from "./ModalEditPlanoLoja.vue?vue&type=template&id=0286b750&scoped=true&ts=true"
import script from "./ModalEditPlanoLoja.vue?vue&type=script&lang=ts"
export * from "./ModalEditPlanoLoja.vue?vue&type=script&lang=ts"

import "./ModalEditPlanoLoja.vue?vue&type=style&index=0&id=0286b750&scoped=true&lang=css"

import exportComponent from "/Users/camp2/Devs/indicar/indicar-gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0286b750"]])

export default __exports__